<script>
import { Confirm } from '../../services/Confirm';

export default {
  props: ['user', 'automation'],

  created () {
    this.getSendings();

    Echo.channel(`tenant.${this.user.account}`)
      .listen('.sending_start', (e) => {
        console.log('Start');
      })
      .listen('.sending_iterate', (e) => {
        if (this.updating === false) {
          this.updateSending(e.sending);
        }
      })
      .listen('.sending_complete', (e) => {
        this.updateSending(e.sending);

        console.log('Complete!');

        Bus.$emit('automationUpdated', this.automation);
      });

    Bus.$on('bulldeskHashChanged', (hash) => {
      if (hash == 'details') {
        this.getSendings();
      }
    });

    Bus.$on('campaignScheduled', () => this.getSendings());
  },

  data () {
    return {
      sendings: [],
      loader: true,
      loading: true,
      updating: false,
    };
  },

  methods: {
    getSendings () {
      this.loader = true;
      this.loading = true;

      this.$http.get(`/automation/${this.automation.id}/sending`)
        .then((response) => {
          this.sendings = response.data;
        })
        .finally((response) => {
          this.loader = false;
          this.loading = false;
          this.updating = false;
        });
    },

    updateSending (sending) {
      if (sending.automation_id != this.automation.id) {
        return;
      }

      this.updating = true;

      const index = this.sendings.findIndex((current) => current.id == sending.id);

      this.sendings.splice(index, 1, sending);

      this.updating = false;
    },

    async destroy (sending) {
      if (! await Confirm(this.__('Deseja cancelar esse agendamento?'))) {
        return;
      }

      this.$http.delete(`/automation/${sending.id}/sending`)
        .then((response) => {
          Alert.success(this.__('Envio cancelado!'));
        })
        .catch((response) => {
          Alert.error(this.__('Esse envio não pode ser cancelado.'));
        })
        .finally((response) => {
          this.getSendings();
        });
    },

    pause (sending) {
      this.$http.put(`/automation/sending/${sending.id}`, { paused: true })
        .then((response) => {
          sending.paused = true;

          Alert.success(this.__('Pausado'));
        })
        .catch((response) => {
          Alert.error(this.__('Esse envio não pode ser modificado.'));
        })
        .finally((response) => {
          this.getSendings();
        });
    },

    resume (sending) {
      this.$http.put(`/automation/sending/${sending.id}`, { paused: false })
        .then((response) => {
          sending.paused = false;

          Alert.success(this.__('Continuando...'));
        })
        .catch((response) => {
          Alert.error(this.__('Esse envio não pode ser modificado.'));
        })
        .finally((response) => {
          this.getSendings();
        });
    },
  },
};
</script>

<template>
  <div
    class="automation-sendings"
    v-if="sendings.length > 0"
  >
    <h3 class="automation-stats__title">
      {{ __('Envios da campanha') }}
    </h3>

    <div class="automation-sendings__content">
      <div class="row">
        <div class="col-md-12">
          <div v-if="loader">
            <i class="fa fa-circle-o-notch fa-spin" />
          </div>

          <div
            class="table-responsive"
            v-else
          >
            <table class="table table-striped table-borderless">
              <thead>
                <tr>
                  <th class="text-center pl-30px">
                    {{ __('Início') }}
                  </th>
                  <th class="text-center">
                    {{ __('Destinatários') }}
                  </th>
                  <th class="text-center">
                    {{ __('Processados') }}
                  </th>
                  <th class="text-center">
                    %
                  </th>
                  <th class="text-center">
                    {{ __('Finalizado') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sending in sendings">
                  <td class="text-center pl-30px">
                    <span v-if="sending.started_at">
                      {{ sending.started_at | datetime }}
                    </span>
                    <span v-else-if="sending.scheduled_at">
                      {{ __('Agendado para') }} {{ sending.scheduled_at | datetime }}
                    </span>
                    <span v-else>
                      {{ __('Aguardando') }}...
                    </span>
                  </td>
                  <td class="text-center">
                    {{ sending.recipients_names }}
                  </td>
                  <td class="text-center">
                    <span v-if="sending.recipient_count">{{ sending.index }} / {{ sending.recipient_count }}</span>
                  </td>
                  <td class="text-center">
                    <span v-if="sending.started_at">
                      {{ (sending.index / sending.recipient_count) | percent(0) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <span v-if="sending.completed_at">
                      {{ sending.completed_at | datetime }}
                    </span>

                    <template v-else>
                      <button
                        class="btn automation-sendings__button"
                        v-if="sending.started_at && !sending.completed_at && !sending.paused"
                        @click.prevent="pause(sending)"
                      >
                        <i class="fa fa-pause" /> Pausar
                      </button>

                      <button
                        class="btn automation-sendings__button"
                        v-if="sending.started_at && !sending.completed_at && sending.paused"
                        @click.prevent="resume(sending)"
                      >
                        <i class="fa fa-play" /> {{ __('Continuar') }}
                      </button>

                      <button
                        class="btn automation-sendings__button"
                        v-if="!sending.started_at && !sending.completed_at && sending.scheduled_at"
                        @click.prevent="destroy(sending)"
                      >
                        {{ __('Cancelar') }}
                      </button>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .automation-sendings {
    &__content {
      background-color: #FFF;
      box-shadow: 0 5px 20px rgba(165, 131, 224, 0.15);
    }
  }
</style>
